import '@boomi/exosphere/dist/icon.js';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import AppShell from './app-shell/AppShell';
import { checkAndRestoreSession, getUser, initializeAuthlib } from './authentication/authUtils';
import AllConnectionsList from './connections/AllConnectionsList';
import Home from './home/Home';
import IdentityProviderGrid from './identity-providers/grid/IdentityProviderGrid';
import NotFound from './not-found/NotFound';
import { setupPendo } from './pendo';

import './index.css';

import '@boomi/exosphere/dist/icon.js';

initializeAuthlib();

const isAuthenticated = await checkAndRestoreSession();

const basename =
    window.location.pathname === '/connect' || window.location.pathname.startsWith('/connect/')
        ? '/connect'
        : '/';

if (isAuthenticated) {
    const user = await getUser();
    const themeFeature = user?.user.Feature?.find((f) => f.key === 'THEME_SELECTION');
    const theme = themeFeature?.extendedProperty === 'DARK' ? 'ex-theme-dark' : 'ex-theme-light';
    document.documentElement.classList.add(theme);

    if (user) {
        setupPendo(user);
    }

    ReactDOM.createRoot(document.getElementById('root')!).render(
        <StrictMode>
            <BrowserRouter basename={basename}>
                <Routes>
                    <Route element={<AppShell />}>
                        <Route index element={<Navigate to="/home" replace />} />
                        <Route path="home" element={<Home />}>
                            <Route path="new" />
                            <Route path="connection/new/:id" />
                            <Route path="connector/:id" />
                            <Route path="connection/:id" />
                        </Route>
                        <Route path="connections" element={<AllConnectionsList />}>
                            <Route path="new" />
                            <Route path="new/:id" />
                            <Route path=":id" />
                            <Route path="connector/:id" />
                        </Route>
                        <Route path="identity-providers" element={<IdentityProviderGrid />}>
                            <Route path="new" />
                            <Route path=":id" />
                        </Route>
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </StrictMode>,
    );
}
